import { render } from "./RegisterBio.vue?vue&type=template&id=4db632de"
import script from "./RegisterBio.vue?vue&type=script&lang=js"
export * from "./RegisterBio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__